import { render, staticRenderFns } from "./WBtnAdd.vue?vue&type=template&id=ac22ef0c&scoped=true&"
import script from "./WBtnAdd.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnAdd.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac22ef0c",
  null
  
)

export default component.exports